export interface Features {
  failingRequestRetriesOnSubmit: number;
  personlizationEnabled: boolean;
}

export function initFeatureFlags(features: Features) {
  features.failingRequestRetriesOnSubmit = 20;
  features.personlizationEnabled = true;
}
